/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation037.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

interface IAnimation037SubItem {
  img: string;
  title: string;
  content: string;
  tip: string;
}

interface IAnimation037Item {
  icon: string;
  text: string;
  subtitle?: string;
  subItems?: IAnimation037SubItem[];
}

interface IAnimation037Props {
  items: IAnimation037Item[];
  tip: string;
  className?: string | null;
  onCompleted: () => void;
}

const Animation037: FunctionComponent<IAnimation037Props> = ({
  items,
  tip,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const [modalItem, setModalItem] = useState<IAnimation037SubItem[]>();

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 800);
    } else {
      console.log('Animation037 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);
  return (
    <div ref={crrRef} className={`animation037 component ${className}`}>
      <div className="animation037-content">
        {items.map((itm: IAnimation037Item, idx: number) => (
          <div
            key={idx}
            className={`animation037-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="animation037-indicate-number">
              <img src={getImg(itm.icon)} alt="" />
            </div>
            <div className="animation037-subcontent">
              {itm.text}
              {itm.subtitle ? (
                <span className="view-more">
                  <Button
                    className="view-more-btn"
                    style={{ fontSize: '1.4rem' }}
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalOpen(true);
                      setModalItem(itm.subItems);
                      setShow([...show, idx]);
                    }}
                  >
                    {itm.subtitle}
                    <img
                      className="click-point1"
                      hidden={!show2}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </span>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {tip && (
        <div className="animation037-tip">
          <div className="tip" dangerouslySetInnerHTML={{ __html: tip }} />
        </div>
      )}
      {modalItem && (
        <Modal
          width="80%"
          className="animation037-modal-general2024"
          title={
            <div className="animation037-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <>
              <div
                className="tip"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.tip,
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.content,
                }}
              />
            </>
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow2([...show2, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation037;
